import React, { useContext } from "react";
import dynamic from "next/dynamic";

import { AppContext } from "@vahak/core/dist/app-context";
import { useCsDashboard } from "@vahak/core/dist/hooks/useCsDashboard";
import { ILorryPostingContextData, useLoadLorryPosting } from "../context/load-lorry-posting";
import { useDetailsPageContext } from "../DetailsPageContextProvider";
import StandaloneLorryPostingFormModal from "./posting/lorry-posting/standalone-lorry-posting-form-modal/StandaloneLorryPostingFormModal";
import LorryNotAllowedPopup from "./posting/load-posting/standalone-load-posting-form-modal/LorryNotAllowedPopup";
import { DownloadAppQrModalHost } from "./common/download-app-qr-modal/DownloadAppAction";

const StandaloneLoadPostingFormModal = dynamic(
    () => import("./posting/load-posting/standalone-load-posting-form-modal/StandaloneLoadPostingFormModal"),
    { ssr: false }
);

const LiveLorryLocationModalWrapper = dynamic(
    () =>
        import(
            "../../nextjs/components/load-lorry-details/components/intransit-lorry-location/LiveLorryLocationModalWrapper/LiveLorryLocationModalWrapper"
        ),
    {
        ssr: false
    }
);

export interface CommonGlobalComponentsWrapperProps {}

const CommonGlobalComponentsWrapper = ({}: CommonGlobalComponentsWrapperProps) => {
    const { isLorryNotAllowedPopupOpen, toggleIsLorryNotAllowedPopupOpen } = useContext(AppContext);
    const { isCsDashboardUser } = useCsDashboard();
    const { loadLorryData } = useLoadLorryPosting();
    const { type, data, isModalOpen, originationPage } = loadLorryData ?? {};
    const loadData = type === "load" ? data : undefined;
    const lorryData = type === "lorry" ? data : undefined;

    const { detailsPageData } = useDetailsPageContext();

    /**
     * Consumer users use compact load posting for post and re-post.
     * Legacy modal stays for CS dashboard users and admin edit flows.
     * Expected-price uses its own modal via isUpdateExpectedPriceModalOpen.
     */
    const showLegacyLoadModal =
        isModalOpen && type === "load" && (isCsDashboardUser || loadLorryData?.category === "edit");

    return (
        <>
            {showLegacyLoadModal && (
                <StandaloneLoadPostingFormModal editLoadData={loadData} originationPage={originationPage} />
            )}
            {isModalOpen && type === "lorry" && (
                <StandaloneLorryPostingFormModal
                    editLorryData={lorryData}
                    originationPage={originationPage}
                    KamClientSupplierCompanyId={(loadLorryData as ILorryPostingContextData)?.companyId}
                />
            )}

            {detailsPageData?.openLorryLocationModal && <LiveLorryLocationModalWrapper />}
            {isLorryNotAllowedPopupOpen && (
                <LorryNotAllowedPopup
                    isModalOpen={isLorryNotAllowedPopupOpen}
                    toggleModal={() => toggleIsLorryNotAllowedPopupOpen()}
                />
            )}
            <DownloadAppQrModalHost />
        </>
    );
};

export default CommonGlobalComponentsWrapper;
